import * as React from "react";
import {cx} from "emotion";

import "./modal-service-3.scss";

import {cc}                    from "../../react/callback-chain";
import {cs}                    from "../../react/chain-services";
import {fragments}             from "../../react/fragments";
import {Types}                 from "../../types";
import {addURLParameter}       from "../../utils/add-url-parameter";
import {removeURLParameter}    from "../../utils/remove-url-parameter";
import {OnGlobalKeyDownEscape} from "../browser/global-key-down-escape";

import {ModalState}  from "./modal-state";
import {Responsive3} from "./responsive-3";
import {DefaultUI}   from "./ui/default-ui/default-ui";

export const URL_QUERY_KEY = "modal";

export const ModalService3:<Params>(props:{
    contentClassName        ?: string,
    contentService          ?: (args:Types.Common.UiComponents.ModalService3.ContentServiceProps<Params>) => any,
    initShow                ?: Params,
    next                    ?: (args:Types.Common.UiComponents.ModalService3.ModalService3Next<Params>) => JSX.Element,
    onClose                 ?: () => Promise<boolean|void>,
    onPassiveClose          ?: () => Promise<boolean|void>,
    ignorePassiveClose      ?: boolean,
    responsive              ?: {[minSize in number|""]: any}, //TODO: improve typing
    rootNext                 : (v:Types.Common.UiComponents.ModalService3.ModalService3RootNext<Params>) => any,
    sidebar                 ?: boolean | {mobileOnly?: boolean, fullHeight?: boolean},
    state                   ?: Pick<Types.Common.React.UseState.UseStateNext<{showing: boolean, params?: Params}>, "onChange" | "value">,
    title                   ?: JSX.Element | string,
    top                     ?: number | string,
    bottom                  ?: number | string,
    urlParam                ?: string,
    header                  ?: any,
    width                   ?: number | "fit-content",
    xToClose                ?: boolean,
    xColor                  ?: string,
    xdQaName                ?: string,
    autoRender              ?: boolean,
    preventBackgroundScroll ?: boolean,
}) => any = ({
    title=undefined,

    sidebar=undefined,
    initShow=undefined,

    state=null,

    contentService=undefined,

    next:getContent=undefined,
    width=undefined,
    top=undefined,
    bottom=undefined,
    header=undefined,
    onClose=undefined,
    onPassiveClose=undefined,
    ignorePassiveClose=false,
    xToClose=true,
    xColor=undefined,
    responsive=undefined,
    contentClassName=undefined,
    urlParam=undefined,

    xdQaName,
    autoRender=true,
    preventBackgroundScroll=false,

    rootNext, // TODO [Quan]: refactor change to next
}) => cs(
    ["modalState", (_, next) => ModalState({
        initShow,
        state,
        next: (modalState) => rootNext({
            ...modalState,
            show: (params = null, open = true) => {
                if (urlParam) {
                    const newUrl = addURLParameter({
                        url: window.location.toString(),
                        parameter: URL_QUERY_KEY,
                        value: urlParam,
                    });
                    if (newUrl) {
                        window.history.replaceState(window.history.state, null, newUrl);
                    }
                }
                return modalState.show(params, open);
            },
        }),
        onClose,
        autoRender,
        renderUI: (renderParams) => next({
            ...renderParams,
            close: (value) => {
                const closed = renderParams.close(value);
                if (closed && urlParam) {
                    const newUrl = removeURLParameter({
                        url: window.location.toString(),
                        parameter: URL_QUERY_KEY,
                    });
                    if (newUrl) {
                        window.history.replaceState(window.history.state, null, newUrl);
                    }
                }
            },
        }),
    })],
    ({modalState: {transitioning, close, params,}}) => cs(
        ["responsive", (_, next) => !responsive ? next(null) : Responsive3({responsive, next})],
        ["content", ({responsive}, next) => {
            const contentParams = {
                params,
                close,
                transitioning: transitioning.active,
            };

            return cc([
                (_, next) => contentService ? (
                    contentService({
                        ...contentParams,
                        next,
                    })
                ) : (
                    next({
                        getContent: () => getContent(contentParams),
                    })
                ),
                (content, next) => next({
                    width,
                    top,
                    bottom,
                    ...responsive,
                    onPassiveClose,
                    ...content,
                }),
                next,
            ]);
        }],
        ({content}) => {
            const passiveClose = async () => {
                const hide = await (content.onPassiveClose || null)?.();
                if (hide !== false) {
                    // passiveClose always resolves false
                    await close(false);
                }
            };
            return fragments(
                DefaultUI({
                    sidebar,
                    transitioning,
                    top   : content.top,
                    bottom: content.bottom,
                    width : content.width,
                    onPassiveClose: passiveClose,
                    ignorePassiveClose,
                    contentClassName,
                    getContent: () => <>
                        {(content.title ?? title) && (
                            <div {...{
                                className: cx("modal-service-3-3oo title", {noBorder: header?.noBorder}),

                                "xd-qa-type": "label",
                                "xd-qa-name": (xdQaName ?? "Default Modal") + " Title",
                            }}>
                                {content.title ?? title}
                            </div>
                        )}
                        {content.getContent ? content.getContent() : content.content}
                    </>,
                    xToClose,
                    xColor,
                    preventBackgroundScroll,
                    xdQaName,
                }),
                OnGlobalKeyDownEscape({
                    action: !ignorePassiveClose && passiveClose,
                })
            );
        },
    )
);
